import {makeStyles} from "@mui/styles";
import { alignItems, flexDirection } from "@mui/system";

export const useStyles = makeStyles({
  filters: {
    marginBottom: 0,
    '@media (max-width: 767px)': {
      marginBottom: 0,
    }
  },
  filterWrapper: {
    padding: '16px 36px',
    '@media (max-width: 1200px)': {
      padding: '16px 24px',
    }
  },
  content: {},
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 0,
  },
  headerBottomWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
    '& > *': {
      marginBottom: '0!important',
    },
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'start',
      gap: 16,
    }
  },
  allDataToggle: {
    '@media (max-width: 767px)': {
      paddingLeft: 6,
      marginBottom: 16,
    },
  },
});
